import { AuthModel } from './auth.model';
import { AddressModel } from './address.model';
import { SocialNetworksModel } from './social-networks.model';

export class UserModel extends AuthModel {
  id: number;
  username: string;
  password: string;
  fullname: string;
  email: string;
  pic: string;
  roles: string[];
  permissions: string[];
  occupation: string;
  companyName: string;
  phone: string;
  address?: AddressModel;
  socialNetworks?: SocialNetworksModel;
  // personal information
  firstname: string;
  lastname: string;
  website: string;
  consignmentType: string;
  // account information
  language: string;
  timeZone: string;
  communication: {
    email: boolean;
    sms: boolean;
    phone: boolean;
  };
  token?: string;
  /** ISO 8601 UTC — access token'ın (JWT) ne zaman dolacağı. Proaktif refresh zamanlayıcısı için kullanılır. */
  accessTokenExpiresAt?: string;
  name: string;
  photo: string;
  photoId?: string;
  branchId: string;
  branchName: string;
  companyLogo: string;
  companyLogoUrl?: string;
  companyLogoId?: string;
  applicationId?: string;
  /** Efektif application'in UI temasi (Login/UserRefreshData'dan gelir). */
  themeName?: string;
  /** Kimlik doğrulama kaynağı: 'Local' | 'Saml' | 'Ldap' (Login/RefreshToken/UserRefreshData'dan gelir).
   *  'Ldap' kullanıcılarında şifre değiştirme arayüzü gizlenir — şifre kurumsal dizinde yönetilir. */
  authProvider?: string;

  // email settings
  emailSettings?: {
    emailNotification: boolean;
    sendCopyToPersonalEmail: boolean;
    activityRelatesEmail: {
      youHaveNewNotifications: boolean;
      youAreSentADirectMessage: boolean;
      someoneAddsYouAsAsAConnection: boolean;
      uponNewOrder: boolean;
      newMembershipApproval: boolean;
      memberRegistration: boolean;
    };
    updatesFromKeenthemes: {
      newsAboutKeenthemesProductsAndFeatureUpdates: boolean;
      tipsOnGettingMoreOutOfKeen: boolean;
      thingsYouMissedSindeYouLastLoggedIntoKeen: boolean;
      newsAboutMetronicOnPartnerProductsAndOtherServices: boolean;
      tipsOnMetronicBusinessProducts: boolean;
    };
  };

  setUser(_user: unknown) {
    const user = _user as UserModel;
    this.id = user.id;
    this.username = user.username || '';
    this.password = user.password || '';
    this.fullname = user.fullname || '';
    this.email = user.email || '';
    this.pic = user.pic || './assets/media/avatars/blank.png';
    this.roles = user.roles || [];
    this.occupation = user.occupation || '';
    this.companyName = user.companyName || '';
    this.phone = user.phone || '';
    this.address = user.address;
    this.socialNetworks = user.socialNetworks;
    this.token = user.token;
    this.permissions = user.permissions;
    this.photo = user.photo;
    this.photoId = user.photoId;
    this.branchName = user.branchName;
    this.branchId = user.branchId;
    this.consignmentType = user.consignmentType;
    this.companyLogo = user.companyLogo;
    this.companyLogoUrl = user.companyLogoUrl;
    this.companyLogoId = user.companyLogoId;
    this.applicationId = user.applicationId;
    this.themeName = user.themeName;
    this.authProvider = user.authProvider;
  }
}
